import { render, staticRenderFns } from "./Different.vue?vue&type=template&id=5e5b427c&scoped=true&"
import script from "./Different.vue?vue&type=script&lang=js&"
export * from "./Different.vue?vue&type=script&lang=js&"
import style0 from "./Different.vue?vue&type=style&index=0&id=5e5b427c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5b427c",
  null
  
)

export default component.exports